// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page {
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    position: relative;
}

.page-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.page-component {
    width: 90%;
    max-width: 2000px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    /* padding-left: 12.5%;
    padding-right: 12.5%; */
    padding-top: 25px;
}

.article-component {
    width: 80%;
    height: 60vh;
    min-height: 500px;
    max-height: 600px;

    display: flex;
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;

    background-color: #D7ECE1;
}

.article-component-image-container {
    width: 50%;
    height: 100%;
    max-width: 650px;
    /*border: 1px solid black;*/
}

.article-component-image {
    position: relative;
    width: 80%;
    height: 80%;
    margin-right: 7.5%;
    margin-left: 7.5%;
    top: 10%;

    /*border: 1px solid black;*/
}

.article-component-text {
    position: relative;
    width: 50%;
    height: 80%;
    top: 12%;
    color: #01483F;

    /*border: 1px solid black;*/
}

.article-component-title {
    padding-bottom: 2%;

    font-size: 3em;
    font-weight: 700;

    /*border: 1px solid black;*/
}

.article-component-sub-title {
    padding-bottom: 2%;

    font-size: 1.35em;
    font-weight: 550;
    color: #E65924;

    /*border: 1px solid black;*/
}

.article-component-description {
    font-size: 1.2em;
    font-weight: 500;

    /*border: 1px solid black;*/
}


@media only screen and (max-width: 1100px) {
    .article-component {
        width: 80%;
        height: auto;
        min-height: auto;
        max-height: none;

        display: flex;
        flex-direction: column;
        justify-content: center;

        background-color: #D7ECE1;
    }

    .article-component-image-container {
        width: 70%;
        margin: 10px 5%;
        height: 75%;
        max-width: none;
        /*border: 1px solid black;*/
    }

    .article-component-image {
        position: static;
        margin: 0;
        width: 100%;
        height: 100%;
        padding-top: 20px;
    }

    .article-component-text {
        position: static;
        width: 90%;
        margin: 0 5% 50px 5%;
        height: 80%;
        top: 0;
        color: #01483F;
    }

    .article-component-title {
        padding-bottom: 2%;
        font-size: 1.8em;
        font-weight: 700;

        /*border: 1px solid black;*/
    }

    .article-component-sub-title {
        padding-bottom: 2%;
        font-size: 1.2em;
        font-weight: 550;
        color: #E65924;

        /*border: 1px solid black;*/
    }

    .article-component-description {
        font-size: 1em;
        font-weight: 500;
        /*border: 1px solid black;*/
    }

    .first-component {
        width: 100vw;
        height: auto;
        position: relative;
        margin-bottom: 12px;
    }

    #first-component-image{
        position: relative;
        z-index: 8;
        width: 100%;
        height: auto;
    }

    #first-component-text{
        position: absolute;

        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;

        top: 55px;
        font-size: 1.5em;
        z-index: 10;
        text-align: center;
        font-weight: bold;
    }
    .lock-scroll{
        overflow: clip;
    }
}

@media screen and (max-width: 555px) {
    #first-component-text{
        position: absolute;

        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;

        top: 50px;
        font-size: 1em;
        z-index: 10;
        text-align: center;
        font-weight: bold;
    }

    .article-component-title {
        font-size: 1.3em;
    }

    .article-component-sub-title {
        font-size: 1em;
        font-weight: 600;
    }
    .article-component-description {
        font-size: 0.85em;
    }
}

@media screen and (max-width: 355px) {
    #first-component-text{
        position: absolute;

        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;

        top: 40px;
        font-size: 0.7em;
        z-index: 10;
        text-align: center;
        font-weight: bold;
    }
}

@media screen and (max-width: 255px) {
    #first-component-text{
        position: absolute;

        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;

        top: 25px;
        font-size: 0.3em;
        z-index: 10;
        text-align: center;
        font-weight: bold;
    }
}

.fc-desktop-image{
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
    z-index: 1;
}

.fc-desktop-container{
    width: 100%;
    height: 500px;
    top: 150px;
    position: absolute;
    z-index: 2;
}

#message{
    text-align: left;
    height: 150px;
}`, "",{"version":3,"sources":["webpack://./src/App/style.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;IAEnB;2BACuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;;IAEjB,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;;IAElB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;;IAER,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,cAAc;;IAEd,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;;IAElB,cAAc;IACd,gBAAgB;;IAEhB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;;IAElB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;;IAEd,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;;IAEhB,2BAA2B;AAC/B;;;AAGA;IACI;QACI,UAAU;QACV,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;;QAEhB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;;QAEvB,yBAAyB;IAC7B;;IAEA;QACI,UAAU;QACV,eAAe;QACf,WAAW;QACX,eAAe;QACf,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,UAAU;QACV,oBAAoB;QACpB,WAAW;QACX,MAAM;QACN,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;;QAEhB,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;;QAEd,2BAA2B;IAC/B;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,2BAA2B;IAC/B;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;;QAElB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;;QAEvB,SAAS;QACT,gBAAgB;QAChB,WAAW;QACX,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,kBAAkB;;QAElB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;;QAEvB,SAAS;QACT,cAAc;QACd,WAAW;QACX,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;;QAElB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;;QAEvB,SAAS;QACT,gBAAgB;QAChB,WAAW;QACX,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;;QAElB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;;QAEvB,SAAS;QACT,gBAAgB;QAChB,WAAW;QACX,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB","sourcesContent":[".page {\r\n    width: 100vw;\r\n    height: 100vh;\r\n    overflow-x: hidden;\r\n    position: relative;\r\n}\r\n\r\n.page-container {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.page-component {\r\n    width: 90%;\r\n    max-width: 2000px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    /* padding-left: 12.5%;\r\n    padding-right: 12.5%; */\r\n    padding-top: 25px;\r\n}\r\n\r\n.article-component {\r\n    width: 80%;\r\n    height: 60vh;\r\n    min-height: 500px;\r\n    max-height: 600px;\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n\r\n    background-color: #D7ECE1;\r\n}\r\n\r\n.article-component-image-container {\r\n    width: 50%;\r\n    height: 100%;\r\n    max-width: 650px;\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.article-component-image {\r\n    position: relative;\r\n    width: 80%;\r\n    height: 80%;\r\n    margin-right: 7.5%;\r\n    margin-left: 7.5%;\r\n    top: 10%;\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.article-component-text {\r\n    position: relative;\r\n    width: 50%;\r\n    height: 80%;\r\n    top: 12%;\r\n    color: #01483F;\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.article-component-title {\r\n    padding-bottom: 2%;\r\n\r\n    font-size: 3em;\r\n    font-weight: 700;\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.article-component-sub-title {\r\n    padding-bottom: 2%;\r\n\r\n    font-size: 1.35em;\r\n    font-weight: 550;\r\n    color: #E65924;\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.article-component-description {\r\n    font-size: 1.2em;\r\n    font-weight: 500;\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n\r\n@media only screen and (max-width: 1100px) {\r\n    .article-component {\r\n        width: 80%;\r\n        height: auto;\r\n        min-height: auto;\r\n        max-height: none;\r\n\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n\r\n        background-color: #D7ECE1;\r\n    }\r\n\r\n    .article-component-image-container {\r\n        width: 70%;\r\n        margin: 10px 5%;\r\n        height: 75%;\r\n        max-width: none;\r\n        /*border: 1px solid black;*/\r\n    }\r\n\r\n    .article-component-image {\r\n        position: static;\r\n        margin: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        padding-top: 20px;\r\n    }\r\n\r\n    .article-component-text {\r\n        position: static;\r\n        width: 90%;\r\n        margin: 0 5% 50px 5%;\r\n        height: 80%;\r\n        top: 0;\r\n        color: #01483F;\r\n    }\r\n\r\n    .article-component-title {\r\n        padding-bottom: 2%;\r\n        font-size: 1.8em;\r\n        font-weight: 700;\r\n\r\n        /*border: 1px solid black;*/\r\n    }\r\n\r\n    .article-component-sub-title {\r\n        padding-bottom: 2%;\r\n        font-size: 1.2em;\r\n        font-weight: 550;\r\n        color: #E65924;\r\n\r\n        /*border: 1px solid black;*/\r\n    }\r\n\r\n    .article-component-description {\r\n        font-size: 1em;\r\n        font-weight: 500;\r\n        /*border: 1px solid black;*/\r\n    }\r\n\r\n    .first-component {\r\n        width: 100vw;\r\n        height: auto;\r\n        position: relative;\r\n        margin-bottom: 12px;\r\n    }\r\n\r\n    #first-component-image{\r\n        position: relative;\r\n        z-index: 8;\r\n        width: 100%;\r\n        height: auto;\r\n    }\r\n\r\n    #first-component-text{\r\n        position: absolute;\r\n\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        justify-content: center;\r\n\r\n        top: 55px;\r\n        font-size: 1.5em;\r\n        z-index: 10;\r\n        text-align: center;\r\n        font-weight: bold;\r\n    }\r\n    .lock-scroll{\r\n        overflow: clip;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 555px) {\r\n    #first-component-text{\r\n        position: absolute;\r\n\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        justify-content: center;\r\n\r\n        top: 50px;\r\n        font-size: 1em;\r\n        z-index: 10;\r\n        text-align: center;\r\n        font-weight: bold;\r\n    }\r\n\r\n    .article-component-title {\r\n        font-size: 1.3em;\r\n    }\r\n\r\n    .article-component-sub-title {\r\n        font-size: 1em;\r\n        font-weight: 600;\r\n    }\r\n    .article-component-description {\r\n        font-size: 0.85em;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 355px) {\r\n    #first-component-text{\r\n        position: absolute;\r\n\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        justify-content: center;\r\n\r\n        top: 40px;\r\n        font-size: 0.7em;\r\n        z-index: 10;\r\n        text-align: center;\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 255px) {\r\n    #first-component-text{\r\n        position: absolute;\r\n\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        justify-content: center;\r\n\r\n        top: 25px;\r\n        font-size: 0.3em;\r\n        z-index: 10;\r\n        text-align: center;\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n.fc-desktop-image{\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.fc-desktop-container{\r\n    width: 100%;\r\n    height: 500px;\r\n    top: 150px;\r\n    position: absolute;\r\n    z-index: 2;\r\n}\r\n\r\n#message{\r\n    text-align: left;\r\n    height: 150px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
